import Headroom from "headroom.js";
import dropdownEvent from "../base/_dropdownEvent.js";

export default class Header {
	constructor(opts = {}) {
		this.node = document.querySelector(".header");

		if (!this.node) {
			return;
		}

		this.opts = Object.assign({}, opts);

		// headroom
		this.headroom = new Headroom(this.node, {
			tolerance: {
				up: 7,
				down: 5,
			},
			classes: {
				initial: "header",
				pinned: "header--pinned",
				unpinned: "header--unpinned",
				top: "header--top",
				notTop: "header--not-top",
				bottom: "header--bottom",
				notBottom: "header--not-bottom",
				frozen: "header--frozen",
			},
		});

		this.headroom.init();
		this.headroom.update(this.headroom);

		this.search = this.node.querySelector(".header__search");
		this.hamburger = this.node.querySelector(".header__menu");

		// dropdowns
		const intentActivate = (e) => {
			//console.log('intentActivate', e);
			Array.from(e.target.children)
				.filter((node) => node.classList.contains("nav__menu"))
				.forEach((node) => node.classList.add("nav__menu--visible"));
		};

		const intentDeactivate = (e) => {
			//console.log('intentDeactivate', e);
			Array.from(e.target.children)
				.filter((node) => node.classList.contains("nav__menu"))
				.forEach((node) => node.classList.remove("nav__menu--visible"));
		};

		Array.from(
			this.node.querySelectorAll(".nav__menu-item--has-children")
		).forEach((node) => {
			const navLink = node.querySelector(".nav__link");

			if (navLink) {
				// navLink.insertAdjacentHTML('afterend', `<button type="button" class="${this.opts.togglerClass}">+</button>`);
			}

			dropdownEvent(node);
			node.addEventListener("dropdown:activate", intentActivate);
			node.addEventListener("dropdown:deactivate", intentDeactivate);
		});
	}
}
